import { reportUrls } from '../utils/urlResolver';
import axios from '.';

export const getDashboardData = (reportType, section, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.[section],
    params,
  });
};
